module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-1-desktop.jpg?v=19cce1b8";